import React, { useState, useEffect, useRef, useCallback } from "react";
import { getDevEmitter, dev_event } from "./devEvents";
import { Entities } from "../game/state/entityKinds";
import "jsoneditor/dist/jsoneditor.min.css";
import JSONEditor from "jsoneditor";

export const Inspector = () => {
  const [entity, setEntity] = useState<Entities | null>(null);
  const entityRef = useRef(entity);
  const [isEditting, setEditting] = useState(false);
  const jsonEditorContainer: React.MutableRefObject<null | HTMLElement> = useRef(
    null
  );
  const [jsonEditor, setJsonEditor] = useState<JSONEditor | null>(null);

  useEffect(() => {
    const handler = () => {
      setEditting(true);
    };
    const handler2 = () => {
      setEditting(false);
    };
    const listenToEntity = (e: Entities) => {
      setEntity(e);
    };
    getDevEmitter()?.addListener(dev_event.EDIT_LEVEL, handler);
    getDevEmitter()?.addListener(dev_event.SKIP_TO_LEVEL, handler2);
    getDevEmitter()?.addListener(dev_event.Paint_Selected_Resp, listenToEntity);
    return () => {
      getDevEmitter()?.removeListener(dev_event.EDIT_LEVEL, handler);
      getDevEmitter()?.removeListener(dev_event.SKIP_TO_LEVEL, handler2);
      getDevEmitter()?.removeListener(
        dev_event.Paint_Selected_Resp,
        listenToEntity
      );
    };
  }, []);

  const handleJsonChanged = (data) => {
    console.log("in handler", entity, data);
    if (entityRef.current !== null && data) {
      for (const [key, val] of Object.entries(data)) {
        entityRef.current[key] = val;
      }
    }
  };

  const setEditor = useCallback((node) => {
    if (jsonEditorContainer.current) {
      console.log("cleaning up past json editor");
      jsonEditor?.destroy();
    }
    if (node) {
      setJsonEditor(
        new JSONEditor(node, {
          onChangeJSON: handleJsonChanged,
        })
      );
    }
    jsonEditorContainer.current = node;
  }, []);

  useEffect(() => {
    if (entity && jsonEditor) {
      jsonEditor.set({
        ...entity,
        // Unset these properties from the editor.
        ...{ kind: undefined, id: undefined, x: undefined, y: undefined },
      });
      entityRef.current = entity;
    }
    return () => {};
  }, [entity]);
  if (isEditting) {
    return <div ref={setEditor}></div>;
  } else {
    return <span>No edits in play mode</span>;
  }
};
